import {isOriginAnchor} from './isOriginAnchor';
import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isStyleByThresholdsArgs(obj: any): CsvConfigJsonResult {
  let errors = [];
  let valid = true;

  if (!Array.isArray(obj.thresholds)) {
    errors.push({code: 'notArray', key: 'thresholds'});
    valid = false;
  } else {
    obj.thresholds.forEach((threshold) => {
      const resultThreshold = isStyleThreshold(threshold);
      if (!resultThreshold.result) {
        valid = false;
        errors = [...errors, ...resultThreshold.errors];
      }
    });
  }

  if (!Array.isArray(obj.attributes)) {
    errors.push({code: 'notArray', key: 'attributes'});
    valid = false;
  } else {
    let auxValid = true;
    obj.attributes.forEach((attributes) => {
      const resultAttributes = isStyleAttribute(attributes);
      if (!resultAttributes.result) {
        auxValid = false;
        errors = [...errors, ...resultAttributes.errors];
      }
    });
    if (!auxValid) {
      valid = false;
    }
  }
  if (obj.originAnchor === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'originAnchor'});
  } else {
    const resultIsOriginAnchor = isOriginAnchor(obj.originAnchor);
    if (!resultIsOriginAnchor.result) {
      valid = false;
      errors = [...errors, ...resultIsOriginAnchor.errors];
    }
  }

  if (obj.defaultStyle) {
    const resultIsStyle = isStyle(obj.defaultStyle);
    if (!resultIsStyle.result) {
      valid = false;
      errors = [...errors, ...resultIsStyle.errors];
    }
  }

  return {result: valid, errors: errors};
}

function isStyleThreshold(obj: any): CsvConfigJsonResult {
  let errors = [];
  let valid = true;

  if (obj.from === undefined) {
    errors.push({code: 'notExist', key: 'from'});
    valid = false;
  } else if (typeof obj.from !== 'number') {
    errors.push({code: 'notNumber', key: 'from', value: obj.from});
    valid = false;
  }

  if (obj.to === undefined) {
    errors.push({code: 'notExist', key: 'to'});
    valid = false;
  } else if (typeof obj.to !== 'number') {
    errors.push({code: 'notNumber', key: 'to', value: obj.to});
    valid = false;
  }

  const resultIsStyle: CsvConfigJsonResult = isStyle(obj);
  if (!resultIsStyle.result) {
    errors = [...errors, ...resultIsStyle.errors];
  }

  return {result: valid, errors: errors};
}

function isStyle(obj: any): CsvConfigJsonResult {
  let errors = [];
  let valid = true;
  if (obj.backgroundColor !== undefined && typeof obj.backgroundColor !== 'string') {
    errors.push({code: 'notText', key: 'backgroundColor', value: obj.backgroundColor});
    valid = false;
  }

  if (obj.widthPercentage !== undefined && typeof obj.widthPercentage !== 'number') {
    errors.push({code: 'notText', key: 'widthPercentage'});
    valid = false;
  } else if (typeof obj.widthPercentage === 'number' && (obj.widthPercentage > 100 || obj.widthPercentage < 0)) {
    errors.push({code: 'invalidPercentage', key: 'widthPercentage', value: obj.widthPercentage});
    valid = false;
  }

  if (obj.heightPercentage !== undefined && typeof obj.heightPercentage !== 'number') {
    errors.push({code: 'notText', key: 'heightPercentage'});
    valid = false;
  } else if (typeof obj.heightPercentage === 'number' && (obj.heightPercentage > 100 || obj.heightPercentage < 0)) {
    errors.push({code: 'invalidPercentage', key: 'heightPercentage', value: obj.heightPercentage});
    valid = false;
  }

  if (obj.opacityPercentage !== undefined && typeof obj.opacityPercentage !== 'number') {
    errors.push({code: 'notText', key: 'opacityPercentage'});
    valid = false;
  } else if (typeof obj.opacityPercentage === 'number' && (obj.opacityPercentage > 100 || obj.opacityPercentage < 0)) {
    errors.push({code: 'invalidPercentage', key: 'opacityPercentage', value: obj.opacityPercentage});
    valid = false;
  }

  if (obj.visible !== undefined && typeof obj.visible !== 'boolean') {
    errors.push({code: 'notBoolean', key: 'visible', value: obj.visible});
    valid = false;
  }

  return {result: valid, errors: errors};
}

function isStyleAttribute(attr: any): CsvConfigJsonResult {
  let valid: boolean = true;
  let errors = [];
  if (attr !== 'backgroundColor' &&
    attr !== 'widthPercentage' &&
    attr !== 'heightPercentage' &&
    attr !== 'visibility') {
    valid = false;
    errors.push({code: 'invalidValue', key: 'attributes', value: attr});
  }

  return {result: valid, errors: errors};
}
